/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UserUpdateRequestDto = {
  name: string;
  surname: string;
  status: UserUpdateRequestDto.status;
  locale: UserUpdateRequestDto.locale;
};
export namespace UserUpdateRequestDto {
  export enum status {
    PENDING = 'PENDING',
    ACTIVE = 'ACTIVE',
    SUSPENDED = 'SUSPENDED',
    DEACTIVATED = 'DEACTIVATED',
  }
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
}

